module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__bci.2172f560.svg";